import { gql, TypedDocumentNode } from '@apollo/client'
import {
  BackofficeGetDriverBoundPoliciesByMobileNumberDataInterface,
  BackofficeGetDriverBoundPoliciesByMobileNumberInputInterface,
} from './interfaces'

const backofficeGetDriverBoundPoliciesByMobileNumber: TypedDocumentNode<
  BackofficeGetDriverBoundPoliciesByMobileNumberDataInterface,
  BackofficeGetDriverBoundPoliciesByMobileNumberInputInterface
> = gql`
  query BackofficeGetDriverBoundPoliciesByMobileNumber($mobileNumber: String!) {
    backofficeGetDriverBoundPoliciesByMobileNumber(input: $mobileNumber) {
      policyNumber
      policyGroup
      planName
      campaignName
      vehicleNumber
      policySuperAppStatus
      driverAccountMobileNumber
    }
  }
`

export default backofficeGetDriverBoundPoliciesByMobileNumber
